const videoSource = [
  {
    id: "video1",
    src: require("./1_1.mp4"),
  },
  {
    id: "video2",
    src: require("./1_2.mp4"),
  },
  {
    id: "video3",
    src: require("./1_3.mp4"),
  },
];

export default videoSource;
